module.exports = __webpack_public_path__ + "static/media/team13.2e198af9.png";